import React, { Component } from 'react';
import { map } from 'lodash';
import { imageBasePath } from '../../constants/staticData';
import { dateToTime } from '../../helpers';

export default class QueueHistory extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }

    render() {
    const{selectedoption,vehicleInfo} = this.props;
      let dataToDisplay= vehicleInfo ? vehicleInfo : [];
      //(selectedoption == '1')?vehicleInfo.vehicleQueue:vehicleInfo.vehicleHistory;
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return (
        <div>
            <div className="div-table queue-navigation lg-view">
             {dataToDisplay.length>0 &&
             <div>
              <div className="div-table-row-header queue-header table-header-view nopadding">
                <div className="div-table-col-header res-table-view">REQUEST ID</div>
                <div  className="div-table-col-header res-table-view">REQUEST DATE/TIME</div>
                <div  className="div-table-col-header res-table-view">CUSTOMER NAME</div>
                <div  className="div-table-col-header res-table-view">AREA</div>
                <div  className="div-table-col-header res-table-view">EMERGENCY TYPE</div>
                <div  className="div-table-col-header res-table-view">STATUS</div>
              </div>
              {map(dataToDisplay, (info, index) => {
              const createdTime = info.garagejobquotes && info.garagejobquotes.userbookingrequest && new Date(info.garagejobquotes.userbookingrequest.createdAt);
              console.log(info);
                  return (
                      <div className="div-table-row">
                          <div className="div-table-col div-vehicle-data div-adjust-queue res-table-view">{info.garagejobquotes.userbookingrequest.requestid ? info.garagejobquotes.userbookingrequest.requestid: '-'}</div>
                          <div className="div-table-col div-vehicle-data div-adjust-queue res-table-view">
                             <div>
                             {info.garagejobquotes.userbookingrequest && info.garagejobquotes.userbookingrequest.createdAt ? months[createdTime.getMonth()] + ' ' + createdTime.getDate() + ' , ' + createdTime.getFullYear():'-'}</div>
                             <div>{info.garagejobquotes.userbookingrequest && info.garagejobquotes.userbookingrequest.createdAt ? dateToTime(createdTime):'-'}</div>
                          </div> 
                          <div className="div-table-col div-vehicle-data res-table-view">{info.garagejobquotes.userbookingrequest.username ? info.garagejobquotes.userbookingrequest.username:'-'}</div>
                          <div className="div-table-col div-vehicle-data div-adjust-queue res-table-view">{info.garagejobquotes.userbookingrequest.location ? info.garagejobquotes.userbookingrequest.location:'-'}</div>
                          <div className="div-table-col div-vehicle-data res-table-view">{info.garagejobquotes.garagejobquotesdetail[0].name ? info.garagejobquotes.garagejobquotesdetail[0].name:'-'}</div>
                          <div className="div-table-col div-vehicle div-status res-table-view">{info.garagejobquotes.userbookingrequest.displayname ? info.garagejobquotes.userbookingrequest.displayname:'-'}</div>
                      </div>
              )} )}
              </div>
              }
             {
                 dataToDisplay.length == 0 &&
                    <div className="empty-list-display lg-view">
                       <img src={`${imageBasePath}/no_jobs.png`} alt="No User Details"></img>
                       {selectedoption == 1 ?
                       <h5>Looks like there are no Jobs in Queue</h5> :
                       <h5>Looks like there is no Job History for this vehicle</h5>
                       }
                    </div>

              }
            </div>
            <div className="res-view">
                <div className="">
                {dataToDisplay.length>0 && 
                  map(dataToDisplay, (info, index) => {
                    const createdTime = info.garagejobquotes && info.garagejobquotes.userbookingrequest && new Date(info.garagejobquotes.userbookingrequest.createdAt); 
                    console.log('a',info);  
                    return(
                    <div className="row">
                        <div className="col-xs-12 queue-mob-box-wrapper res-mb-5">
                          <div className="row queue-mob-box-inner-row">
                            <div className="col-xs-6 p-0  text-left">
                              REQUEST ID
                            </div>
                            <div className="col-xs-6 p-0 text-right">
                              {info.garagejobquotes.userbookingrequest.requestid ? info.garagejobquotes.userbookingrequest.requestid : '-'}
                            </div>
                          </div>
                          <div className="row queue-mob-box-inner-row">
                            <div className="col-xs-6 p-0 text-left">
                              REQUEST DATE/TIME
                            </div>
                            <div className="col-xs-6 p-0 text-right">
                            <div>
                             {info.garagejobquotes.userbookingrequest && info.garagejobquotes.userbookingrequest.createdAt ? months[createdTime.getMonth()] + ' ' + createdTime.getDate() + ' , ' + createdTime.getFullYear():'-'}</div>
                             {
                               info.garagejobquotes.userbookingrequest && info.garagejobquotes.userbookingrequest.createdAt && 
                                 <div>{dateToTime(createdTime)}</div>
                             }
                            </div>
                          </div>
                          <div className="row queue-mob-box-inner-row">
                            <div className="col-xs-6 p-0 text-left">
                              CUSTOMER NAME
                            </div>
                            <div className="col-xs-6 p-0 text-right">
                              {info.garagejobquotes.userbookingrequest.username ? info.garagejobquotes.userbookingrequest.username : '-'}
                            </div>
                          </div>
                          <div className="row queue-mob-box-inner-row">
                            <div className="col-xs-6 p-0 text-left">
                              AREA
                            </div>
                            <div className="col-xs-6 p-0 text-right">
                             {info.garagejobquotes.userbookingrequest.location ? info.garagejobquotes.userbookingrequest.location : '-'}
                            </div>
                          </div>
                          <div className="row queue-mob-box-inner-row">
                            <div className="col-xs-6 p-0 text-left">
                              EMERGENCY TYPE
                            </div>
                            <div className="col-xs-6 p-0 text-right">
                              {info.garagejobquotes.garagejobquotesdetail[0].name ? info.garagejobquotes.garagejobquotesdetail[0].name : '-'}
                            </div>
                          </div>
                          <div className="row queue-mob-box-inner-row">
                            <div className="col-xs-6 p-0 text-left">
                              STATUS
                            </div>
                            <div className="col-xs-6 p-0 text-right">
                              {info.garagejobquotes.userbookingrequest.displayname ? info.garagejobquotes.userbookingrequest.displayname : '-'}
                            </div>
                          </div>
                        </div>
                    </div>
                    )
                  })
                }
                             {
                 dataToDisplay.length == 0 &&
                    <div className="empty-list-display res-view">
                       <img src={`${imageBasePath}/no_jobs.png`} alt="No User Details"></img>
                       {selectedoption == 1 ?
                       <h5>Looks like there are no Jobs in Queue</h5> :
                       <h5>Looks like there is no Job History for this vehicle</h5>
                       }
                    </div>

              }
                  </div>
            </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MyVehicles/QueueHistory.jsx